// extracted by mini-css-extract-plugin
export default {"preLanderOverlay":"preLanderOverlay__A2vs3","preLanderContent":"preLanderContent__TGkbo","step":"step__zokha","question":"question__jbhIm","odysseus-prelander":"odysseus-prelander__Mozvx","answers":"answers__frCYE","singleAnswer":"singleAnswer__OW_yo","answerButton":"answerButton__Mcyi_","arrowLeft":"arrowLeft__wmpZS","arrowRight":"arrowRight__ZDn5o","buttonMainText":"buttonMainText__JuUWD","arrowBoth":"arrowBoth__KeTLx","finalButton":"finalButton__Tn3Ss","buttonSubtext":"buttonSubtext__v6Ou3"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"preLanderOverlay\":\"preLanderOverlay__A2vs3\",\"preLanderContent\":\"preLanderContent__TGkbo\",\"step\":\"step__zokha\",\"question\":\"question__jbhIm\",\"odysseus-prelander\":\"odysseus-prelander__Mozvx\",\"answers\":\"answers__frCYE\",\"singleAnswer\":\"singleAnswer__OW_yo\",\"answerButton\":\"answerButton__Mcyi_\",\"arrowLeft\":\"arrowLeft__wmpZS\",\"arrowRight\":\"arrowRight__ZDn5o\",\"buttonMainText\":\"buttonMainText__JuUWD\",\"arrowBoth\":\"arrowBoth__KeTLx\",\"finalButton\":\"finalButton__Tn3Ss\",\"buttonSubtext\":\"buttonSubtext__v6Ou3\"}";
        // 1787130557008
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  